export const professionList: { key: number, value: string }[] = [
  { key:1, value: 'কৃষি' },
  { key:2, value: 'ব্যবসা' },
  { key:3, value: 'বেসরকারি চাকরি' },
  { key:4, value: 'সরকারি চাকরি' },
  { key:5, value: 'প্রবাসী' },
  { key:6, value: 'গৃহিণী' },
  { key:7, value: 'দিন মজুর' },
  { key:8, value: 'অবসর' },
  { key:9, value: 'ড্রাইভার' },
  { key:10, value: 'অন্যান্য' },
]

export const vataList: { key: number, value: string }[] = [
  { key:1, value: 'প্রতিবন্ধী ভাতা' },
  { key:2, value: 'বয়স্ক ভাতা' },
  { key:3, value: 'বিধবা ভাতা' },
  { key:4, value: 'মুক্তি যোদ্ধা' },
  { key:5, value: 'অন্যান্য' },
  { key:6, value: 'কোনটিই না' },
]

export const khanaList: { key: number, value: string }[] = [
  { key: 1, value: 'এক চালা' },
  { key: 2, value: 'দুই চালা' },
  { key: 3, value: 'চার চালা' },
  { key: 4, value: 'আধা পাকা' },
  { key: 5, value: 'পাকা' },
  { key: 6, value: 'এক তলা' },
  { key: 7, value: 'দোতলা' },
  { key: 8, value: 'তিনতলা' },
  { key: 9, value: 'চারতলা' },
  { key: 10, value: 'বহুতল' },
]
